import { render, staticRenderFns } from "./Claims.vue?vue&type=template&id=5a06f1de&scoped=true&lang=pug&"
import script from "./Claims.vue?vue&type=script&lang=js&"
export * from "./Claims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a06f1de",
  null
  
)

export default component.exports